import React from "react";
import "./about.scss";

// components
import Wrapper from "../../layouts/wrapper/Wrapper";
import CommonHeader from "../../common/commonHeader/CommonHeader";

// images
import aboutImg from "../../../assets/images/me/about-img.jpeg";
import AboutCard from "../../cards/aboutCard/AboutCard";

// data
import aboutCardData from "../../../assets/data/aboutCardData";
import LayoutAnimations from "../../animations/LayoutAnimations";

const About = () => {
  return (
    <section id="about">
      <Wrapper>
        <div className="about">
          <LayoutAnimations propVarient={"leftToRight"}>
            <div className="about__left">
              <CommonHeader
                title="About"
                subtitle="introduction"
                bgText="About Us"
              />

              <div className="about__content">
                <span className="aboutContent__headText">
                  <span>Our Introduction</span>
                </span>

                <span className="aboutContent__desc">
                  Hello Everyone. We are Shopify Experts. We are professional
                  experienced, professional lead full-stack Developers. We build
                  top-quality, user-friendly and responsive custom websites.{" "}
                  <br />
                  <br /> We are providing E-commerce Management and E-commerce
                  Development Services. We have experience with creating one
                  product shopify website, uploading products, bulk import,
                  converting any vendor or supplier file, shopify shipping and
                  tax setup, shopify speed optimization, importing shopify
                  product reviews, shopify customization, creating shopify csv,
                  writing product descriptions and navigation, menu or
                  mega-manu setup etc.
                  <br />
                  <br />
                  We're dedicated to empowering businesses to thrive in the
                  digital landscape. Let us be your partner in success on the
                  Shopify platform. Get in touch today to discuss how we can
                  elevate your e-commerce journey!
                </span>

                <div className="about__cards">
                  {aboutCardData.map((item, index) => (
                    <AboutCard
                      key={index}
                      icon={item.icon}
                      title={item.title}
                      desc={item.desc}
                    />
                  ))}
                </div>
              </div>
            </div>
          </LayoutAnimations>

          <LayoutAnimations propVarient={"rightToLeft"}>
            <div className="about__right">
              <img
                src="https://images.pexels.com/photos/7857496/pexels-photo-7857496.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
                alt=""
              />
            </div>
          </LayoutAnimations>
        </div>
      </Wrapper>
    </section>
  );
};

export default About;
